module.exports = __webpack_public_path__ + "static/media/ligamx.9bb37cd3.png";